import {lazy} from 'react';

const paymentRoutes = [
    {
        exact: true,
        path: '/payments',
        component: lazy(() => import('../views/payments'))
    },
    {
        exact: true,
        path: '/FleetSuccess',
        component: lazy(() => import('../views/PaymentSuccess'))
    },
    {
        exact: true,
        path: '/FleetFailed',
        component: lazy(() => import('../views/PaymentFailed'))
    },
    {
        exact: true,
        path: '/PaymentFailed',
        component: lazy(() => import('../views/PaymentFailed'))
    },
    {
        exact: true,
        path: '/PaymentSuccess',
        component: lazy(() => import('../views/PaymentSuccess'))
    },
    {
        exact: true,
        path: '/SellersTab',
        component: lazy(() => import('../views/payments/SellersTab/SellersMainTab'))
    },
    {
        exact: true,
        path: '/payments/manage-autopay',
        component: lazy(() => import('../views/payments/AutopayCard/ManageAutopayPage'))
    },
    {
        exact: true,
        path: '/payments/activity',
        component: lazy(() => import('../views/payments/Tabs/pages/activity'))
    },
    {
        exact: true,
        path: '/payments/analytics',
        component: lazy(() => import('../views/payments/Tabs/pages/analytics'))
    },
    {
        exact: true,
        path: '/payments/analytics/fuel-purchase',
        component: lazy(() => import('../views/payments/Tabs/pages/fuelPurchase'))
    },
    {
        exact: true,
        path: '/payments/analytics/credit-utilisation',
        component: lazy(() => import('../views/payments/Tabs/pages/creditUtilisation'))
    },
    {
        exact: true,
        path: '/payments/analytics/invoice-ageing',
        component: lazy(() => import('../views/payments/Tabs/pages/invoiceAgeing'))
    },
    {
        exact: true,
        path: '/payments/partner/:partnerId',
        component: lazy(() => import('../views/payments/Tabs/pages/partner'))
    },
];

export default paymentRoutes;
